import React, { useState, useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { btnP, crd } from "../../constants/styles";
import Fld from "../common/Fld";

function InvitePage() {
  const { t, h, go, flash } = useContext(Ctx); const [ph, sP] = useState(""); const [nm, sN] = useState("");
  return <div style={{ paddingTop: 16 }}><button onClick={() => go("dash")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
    <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{t.invite}</h2>
    <div data-coach="invite-form" style={{ ...crd(h), padding: 20 }}><Fld l={t.name} v={nm} set={sN} h={h} /><Fld l={t.phone} v={ph} set={sP} h={h} ph="+91 98765 43210" />
      <button onClick={() => {
        if (ph && nm) {
          const text = encodeURIComponent(`🏠 *Welcome to ProRentz!* 🏠\n\nHi ${nm.trim()},\n\nYou have been invited by your landlord to access the Tenant Portal.\n\nFrom our app, you can easily:\n✅ Track your Rent & Common Charges\n✅ Download Payment Receipts\n✅ Submit Maintenance Requests\n✅ e-Sign your Rental Agreement\n\n👉 *Login Here:* ${window.location.origin}\n\nPlease enter your phone number (${ph.trim()}) to securely login.\n\nWelcome home!`);
          const cleanPhone = ph.replace(/\D/g, "");
          window.open(`https://wa.me/${cleanPhone}?text=${text}`, "_blank");
          flash(`${t.inviteWa} ${nm}!`);
          go("dash");
        }
      }} style={btnP(h)}>{t.send} Invite via WhatsApp</button></div></div>;
}

export default InvitePage;
